import AppLayout from "@/components/layout/AppLayout";
import MobileShell from "@/mobile/MobileShell";
import useIsMobile from "@/mobile/useIsMobile";

// Below 768px: the mobile shell. 768px and up: the existing desktop layout,
// unchanged. Both render the same routes (<Outlet />), API and data.
export default function ResponsiveLayout() {
  return useIsMobile() ? <MobileShell /> : <AppLayout />;
}
